import * as _ from "lodash";
import {Pipe, PipeTransform} from "@angular/core";
import { MovimientosEntity } from "../entities/movimientos_entity";
import { AplicacionesTransporteResumen, AplicacionesMovimientos } from "../entities/aplicaciones_transporte_entity";

@Pipe({
    name: "dataFilterAplicacion"
})
export class DataFilterPipe implements PipeTransform {

    transform(array: AplicacionesTransporteResumen[], query: string): any {
        if (query) {
            return _.filter(array, row=> ((row.aplicacion+"").toUpperCase()).indexOf((query.toUpperCase())) > -1);
        }
        return array;
    }
}

@Pipe({
    name: "dataFilterEstado"
})
export class DataFilterPipe2 implements PipeTransform {

    transform(array: AplicacionesTransporteResumen[], query: string): any {
        if (query) {
            return _.filter(array, row=> ((row.estado+"").toUpperCase()).indexOf((query.toUpperCase())) > -1);
        }
        return array;
    }
}

@Pipe({
    name: "dataFilterPedido"
})
export class DataFilterPipe3 implements PipeTransform {

    transform(array: AplicacionesTransporteResumen[], query: string): any {
        if (query) {
            return _.filter(array, row=> ((row.NumeroPedido+"").toUpperCase()).indexOf((query.toUpperCase())) > -1);
        }
        return array;
    }
}

@Pipe({
    name: "dataFilterNumeroAplicacion"
})
export class DataFilterPipe4 implements PipeTransform {

    transform(array: AplicacionesMovimientos[], query: string): any {
        if (query) {
            return _.filter(array, row=> ((row.NumeroAplicacion+"").toUpperCase()).indexOf((query.toUpperCase())) > -1);
        }
        return array;
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/aplicacionesTransporte/aplicaciones-transporte.filter.ts